var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailFooter = function SvgMailFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.3 11q-.536 0-.918-.404A1.37 1.37 0 0 1 0 9.625v-8.25q0-.567.382-.97Q.764 0 1.3 0h10.4q.536 0 .918.404.382.405.382.971v8.25q0 .567-.382.971-.381.405-.918.404zm5.2-4.812L1.3 2.75v6.875h10.4V2.75zm0-1.375 5.2-3.438H1.3zM1.3 2.75V1.375v8.25z"
  })));
};
export default SvgMailFooter;